import { getWorkspaceSelectionKey } from "../workspaceSelection/workspaceSelectionUtils";

export function applySipBulkResultsToComplexes(
  complexes,
  results,
  getClientPatch
) {
  const successfulByKey = new Map(
    results.filter((result) => result.ok).map((result) => [result.key, result])
  );
  const complexPatches = new Map(
    results
      .filter((result) => result.ok && result.complexPatch)
      .map((result) => [String(result.complexId), result.complexPatch])
  );

  if (successfulByKey.size === 0 && complexPatches.size === 0) return complexes;

  return complexes.map((complex) => {
    const clients = Array.isArray(complex?.sipClients)
      ? complex.sipClients
      : Object.values(complex?.sipClients || {});
    let clientsChanged = false;
    const nextClients = clients.map((client) => {
      const key = getWorkspaceSelectionKey({
        entityType: "sipClient",
        complexId: complex._id,
        sipClientId: client?._id,
        clientName: client?.clientName,
      });
      const result = successfulByKey.get(key);
      if (!result) return client;
      const patch = getClientPatch(result);
      if (!patch) return client;
      clientsChanged = true;
      return { ...client, ...patch };
    });
    const complexPatch = complexPatches.get(String(complex._id));

    return clientsChanged || complexPatch
      ? {
          ...complex,
          ...(clientsChanged ? { sipClients: nextClients } : {}),
          ...(complexPatch || {}),
        }
      : complex;
  });
}
